import { createClient } from '@supabase/supabase-js'
import { authStorage } from './auth-storage'

const url = import.meta.env.VITE_SUPABASE_URL
const key = import.meta.env.VITE_SUPABASE_ANON_KEY
export const isSupabaseConfigured = Boolean(url && key && !url.includes('your-project'))
export const isDemoMode = import.meta.env.VITE_DEMO_MODE !== 'false'

export { readRememberSession, setRememberSession } from './auth-storage'

export const supabase = isSupabaseConfigured
  ? createClient(url, key, {
      auth: { persistSession: true, autoRefreshToken: true, storage: authStorage },
    })
  : null
